import { TemplateVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (connectionKey: string): Promise<TemplateVO[]> =>
  fetcher(`/api/user/${connectionKey}/templates`, 'GET', undefined)
